import r from"./primary.js";import e from"./secondary.js";const o={primary:r.blue400,secondary:e.cream400,error:e.red700,warning:e.yellow700,info:r.blue100,success:r.blue700};export{o as default};
//# sourceMappingURL=defaults.js.map
